import { provideWidgetClass } from "scrivito"

export const CreateOpportunityButtonWidget = provideWidgetClass(
  "CreateOpportunityButtonWidget",
  {
    attributes: {
      text: "string",
      data: "datalocator"
    },
    extractTextAttributes: ["text"]
  }
)
